<div class="container">
  <div class="center">
    <p>Your Session has timed out.</p>
    <p>It's a good idea to close all browser windows.</p>
    <p><a routerLink="/login">Click here</a>&nbsp;to login</p>
  </div>
</div>
